{
  "success": {
    "analyses/setMovable": "Analyse aktualisiert",
    "analyses/moveIntoPlan": "Analyse erfolgreich in den Plan verschoben",
    "analyses/remove": "Analyse erfolgreich aus der Planung entfernt",
    "analysisDefinitions/create": "Neue Analysedefinition hinzugefügt",
    "analysisDefinitions/edit": "Analysedefinition bearbeitet",
    "analysisDefinitions/remove": "Analysedefinition gelöscht",
    "analysisDraft/create": "Neuen Analyseentwurf hinzugefügt",
    "analysisDraft/edit": "Analyseentwurf bearbeitet",
    "samples/delete-unlocked": "Alle ungeplanten Proben gelöscht",
    "assets/remove": "Instrument erfolgreich gelöscht",
    "assets/create": "Neues Instrument hinzugefügt",
    "assets/edit": "Instrument bearbeitet",
    "competenceGroups/create": "Neue Kompetenzgruppe erfolgreich erstellt",
    "competenceGroups/edit": "Kompetenzgruppe erfolgreich bearbeitet",
    "competenceGroups/remove": "Kompetenzgruppe erfolgreich gelöscht",
    "iap/run": "IAP erfolgreich ausgeführt",
    "iap/runFillInSamples": "Proben erfolgreich aufgefüllt",
    "integrationSheets/createActionSheet": "Blatt hinzugefügt",
    "integrationSheets/createProjectTemplateSheets": "Blatt hinzugefügt",
    "integrationSheets/createSampleSheet": "Blatt hinzugefügt",
    "integrationSheets/editActionSheet": "Blatt bearbeitet",
    "integrationSheets/editProjectTemplateSheet": "Blatt bearbeitet",
    "integrationSheets/editSampleSheet": "Blatt bearbeitet",
    "integrationSheets/removeActionSheet": "Blatt gelöscht",
    "integrationSheets/removeProjectTemplateSheet": "Blatt gelöscht",
    "integrationSheets/removeSampleSheet": "Blatt gelöscht",
    "integrationSheets/saveSapConversionSheet": "Projektimport-Blatt gespeichert",
    "members/create": "Mitglied hinzugefügt",
    "members/createAsAdmin": "Mitglied hinzugefügt",
    "members/edit": "Mitglied bearbeitet",
    "members/archive": "Mitglied archiviert",
    "projectActions/editPlanned": "Projektaktion bearbeitet",
    "projectActions/move": "Projektaktion in den Zeitplan aufgenommen",
    "projectActions/setMovable": "Projektaktion aktualisiert",
    "projectActions/setLocation": "Standort aktualisiert",
    "projectActions/setLocationUnplanned": "Standort aktualisiert",
    "projectActions/editUnplanned": "Ungeplante Projektaktion bearbeitet",
    "projectActions/removePlanned": "Projekt aus der Planung entfernt",
    "projects/create": "Neues Projekt hinzugefügt",
    "projects/edit": "Projekt aktualisiert",
    "projects/remove": "Projekt gelöscht",
    "projects/delete-unplanned": "Alle ungeplanten Projekte gelöscht",
    "projects/lockProject": "Projekt gesperrt",
    "projects/unlockProject": "Projekt entsperrt",
    "projectTemplates/create": "Neue Projektvorlage erstellt",
    "projectTemplates/createDraft": "Neuen Projektvorlagenentwurf erstellt",
    "projectTemplates/edit": "Projektvorlage bearbeitet",
    "projectTemplates/editDraft": "Projektvorlagenentwurf bearbeitet",
    "projectTemplates/remove": "Projektvorlage gelöscht",
    "whiteTasks/remove": "Aufgabe erfolgreich gelöscht",
    "whiteTasks/create": "Neue Aufgabe hinzugefügt",
    "whiteTasks/edit": "Aufgabe erfolgreich bearbeitet",
    "whiteTasks/createRecurrence": "Wiederholung erstellt",
    "whiteTasks/removeRecurrence": "Wiederkehrende Aufgaben entfernt",
    "teamStatus/start": "Simulationsmodus gestartet",
    "teamStatus/accept": "Änderungen im Simulationsmodus angewendet",
    "teamStatus/discard": "Änderungen im Simulationsmodus verworfen",
    "customers/addCustomer": "Kunde hinzugefügt",
    "customers/editCustomer": "Kunde bearbeitet",
    "customers/deleteCustomer": "Kunde gelöscht",
    "team/create-api-token": "API-Token erstellt",
    "team/delete-api-token": "API-Token gelöscht"
  },
  "error": {
    "analyses/remove/ERROR": "Entfernen der Analyse aus der Planung fehlgeschlagen",
    "analysisDefinitions/create/ERROR": "Hinzufügen einer neuen Analysedefinition fehlgeschlagen",
    "analysisDefinitions/remove/ERROR": "Löschen der Analysedefinition fehlgeschlagen",
    "assets/remove/ERROR": "Löschen des Instruments fehlgeschlagen",
    "assets/create/ERROR": "Hinzufügen des Instruments fehlgeschlagen",
    "auth/login/ERROR": "Anmeldung fehlgeschlagen",
    "competenceGroups/create/ERROR": "Erstellen der Kompetenzgruppe fehlgeschlagen",
    "competenceGroups/remove/ERROR": "Löschen der Kompetenzgruppe fehlgeschlagen",
    "iap/run/ERROR": "Ausführen von IAP fehlgeschlagen",
    "iap/runFillInSamples/ERROR": "Auffüllen der Proben fehlgeschlagen",
    "integrationSheets/createActionSheet/ERROR": "Hinzufügen des Blatts fehlgeschlagen",
    "integrationSheets/createProjectTemplateSheets/ERROR": "Hinzufügen des Blatts fehlgeschlagen",
    "integrationSheets/createSampleSheet/ERROR": "Hinzufügen des Blatts fehlgeschlagen",
    "integrationSheets/editActionSheet/ERROR": "Bearbeiten des Blatts fehlgeschlagen",
    "integrationSheets/editProjectTemplateSheet/ERROR": "Bearbeiten des Blatts fehlgeschlagen",
    "integrationSheets/editSampleSheet/ERROR": "Bearbeiten des Blatts fehlgeschlagen",
    "integrationSheets/removeActionSheet/ERROR": "Beim Versuch, das Blatt zu löschen, ist ein Fehler aufgetreten",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "Beim Versuch, das Blatt zu löschen, ist ein Fehler aufgetreten",
    "integrationSheets/removeSampleSheet/ERROR": "Beim Versuch, das Blatt zu löschen, ist ein Fehler aufgetreten",
    "loading/fetchAll/ERROR": "Laden fehlgeschlagen",
    "members/create/ERROR": "Hinzufügen des Mitglieds fehlgeschlagen",
    "members/createAsAdmin/ERROR": "Hinzufügen des Mitglieds fehlgeschlagen",
    "members/archive/ERROR": "Archivieren des Mitglieds fehlgeschlagen",
    "projectActions/move/ERROR": "Verschieben der Aktion in den Zeitplan fehlgeschlagen",
    "projectActions/removePlanned/ERROR": "Entfernen der Aktion aus der Planung fehlgeschlagen",
    "projectActions/setLocation/ERROR": "Aktualisieren des Standorts fehlgeschlagen",
    "projectActions/setLocationUnplanned/ERROR": "Aktualisieren des Standorts fehlgeschlagen",
    "projects/create/ERROR": "Hinzufügen eines neuen Projekts fehlgeschlagen",
    "projects/remove/ERROR": "Löschen des Projekts fehlgeschlagen",
    "projects/delete-unplanned/ERROR": "Löschen ungeplanter Projekte fehlgeschlagen",
    "projects/lockProject/ERROR": "Sperren von Aktionen fehlgeschlagen",
    "projectTemplates/create/ERROR": "Erstellen einer neuen Projektvorlage fehlgeschlagen",
    "projectTemplates/createDraft/ERROR": "Erstellen eines neuen Projektvorlagenentwurfs fehlgeschlagen",
    "projectTemplates/remove/ERROR": "Löschen der Projektvorlage fehlgeschlagen",
    "whiteTasks/remove/ERROR": "Löschen der Aufgabe fehlgeschlagen",
    "whiteTasks/create/ERROR": "Erstellen fehlgeschlagen",
    "teamStatus/start/ERROR": "Starten des Simulationsmodus fehlgeschlagen",
    "teamStatus/accept/ERROR": "Anwenden der Änderungen im Simulationsmodus fehlgeschlagen",
    "teamStatus/discard/ERROR": "Verwerfen der Änderungen im Simulationsmodus fehlgeschlagen",
    "customers/deleteCustomer/ERROR": "Der Kunde konnte nicht gelöscht werden",
    "customers/addCustomer/ERROR": "Der Kunde konnte nicht hinzugefügt werden",
    "customers/editCustomer/ERROR": "Der Kunde konnte nicht bearbeitet werden",
    "team/create-api-token/ERROR": "API-Token konnte nicht erstellt werden",
    "team/delete-api-token/ERROR": "API-Token konnte nicht gelöscht werden"
  },
  "adhoc": {
    "welcomeBack": "Willkommen zurück!",
    "noSoundDetected": "Kein Ton erkannt. Bitte versuchen Sie es erneut.",
    "noMicrophoneDetected": "Kein Mikrofon erkannt. Bitte versuchen Sie es erneut.",
    "iapRunning": "Einen Moment bitte - das IAP für Ihr Team wird ausgeführt",
    "failedDiscardNotLoggedOut": "Verwerfen der Änderungen fehlgeschlagen. Sie wurden nicht abgemeldet!",
    "cannotDragRecurrentTask": "Sie können eine wiederkehrende GreyTask nicht per Drag-and-Drop verschieben",
    "cannotMoveImportedTasks": "Sie können importierte Aufgaben nicht verschieben",
    "noCheckboxesSelected": "Keine Kontrollkästchen ausgewählt",
    "analysisUpdatedRefresh": "Analyse aktualisiert, bitte aktualisieren",
    "analysisUpdatedByAnotherUser": "Die Analyse wurde von einem anderen Benutzer aktualisiert, bitte aktualisieren Sie",
    "copiedToClipboard": "In die Zwischenablage kopiert",
    "couldNotCopyToClipboard": "Konnte nicht in die Zwischenablage kopieren",
    "chooseFirstAction": "Bitte wählen Sie das erste {{itemType}}",
    "chooseSecondAction": "Bitte wählen Sie das zweite {{itemType}}",
    "chooseTwoDifferent": "Bitte wählen Sie zwei unterschiedliche {{itemType}}",
    "constraintConflicts": "Diese Beschränkung steht im Konflikt mit bestehenden Beschränkungen",
    "sampleCreated": "Probe erstellt",
    "sampleDeleted": "Probe gelöscht",
    "samplesUpdated": "Proben aktualisiert",
    "sampleMarkedDone": "Probe als erledigt markiert",
    "memberPermissionsChanged": "Mitgliedsberechtigungen geändert",
    "chooseUniqueName": "Bitte wählen Sie einen eindeutigen Namen",
    "fillRequiredFields": "Bitte füllen Sie die erforderlichen Felder aus",
    "couldNotDetermineSampleIdDone": "Die Proben-ID zum Markieren als erledigt konnte nicht ermittelt werden",
    "couldNotDetermineSampleIdDelete": "Die Proben-ID zum Löschen konnte nicht ermittelt werden",
    "couldNotDetermineSampleIdDeleteMissing": "Die Proben-ID zum Löschen konnte nicht ermittelt werden - Daten fehlen. Prüfen Sie die Konsole für Details.",
    "anErrorOccurred": "Ein Fehler ist aufgetreten",
    "selectFileBeforeSubmitting": "Bitte wählen Sie vor dem Absenden mindestens eine Datei aus",
    "helpPageUpdated": "Hilfeseite aktualisiert",
    "processingStarted": "Verarbeitung gestartet",
    "failedLoadingIcalFiles": "Laden der iCalendar-Dateien fehlgeschlagen",
    "unsortBeforePasting": "Bitte heben Sie die Sortierung der Tabelle auf, bevor Sie mehrere Zellen einfügen.",
    "fillAllRequiredFields": "Bitte füllen Sie alle erforderlichen Felder aus",
    "unsavedChangesConfirmLeave": "Sie haben ungespeicherte Änderungen. Um zu bestätigen, dass Sie die Seite verlassen möchten, drücken Sie erneut die Zurück-Taste.",
    "provideSheetName": "Bitte geben Sie einen Blattnamen an",
    "sheetNameAlreadyExists": "Ein Blatt mit diesem Namen existiert bereits",
    "provideSheetType": "Bitte geben Sie einen Blatttyp an",
    "didNotSpellDeleteProperly": "Sie haben DELETE nicht korrekt geschrieben",
    "domainMustStartWithAt": "Die Domain muss mit '@' beginnen",
    "fillOutRequiredFields": "Bitte füllen Sie die erforderlichen Felder aus",
    "selectValidDates": "Bitte wählen Sie gültige Daten aus",
    "noIapModeSelected": "Kein IAP-Modus ausgewählt. Bitte wählen Sie einen Modus aus.",
    "oneCollaboratorForWorkday": "Beim Prüfen des gesamten Arbeitstags darf nur ein Mitarbeitender ausgewählt sein",
    "fillRequiredDateTimeFields": "Bitte füllen Sie alle erforderlichen Datums- und Zeitfelder aus",
    "endMustBeAfterStart": "Das Ende der Aufgabe muss nach dem Start liegen",
    "recurrencesCannotExceed365": "Die Anzahl der Wiederholungen darf nicht größer als 365 sein",
    "pleaseFillNumberAndInterval": "Bitte füllen Sie Anzahl und Intervall der Wiederholungen aus",
    "pleaseFillNumberOfRecurrences": "Bitte füllen Sie die Anzahl der Wiederholungen aus",
    "pleaseFillIntervalOfRecurrences": "Bitte füllen Sie das Intervall der Wiederholungen aus",
    "pleaseFillAllPeriodFields": "Bitte füllen Sie alle Zeitraumfelder aus",
    "pleaseSelectReportType": "Bitte wählen Sie mindestens einen Berichtstyp aus",
    "reportEmptyInInterval": "Die Datei {{fileName}} ist im angegebenen Intervall leer",
    "promptTooLong": "Prompt zu lang (maximal 1200 Zeichen)",
    "nameTooLong": "Name zu lang (maximal 100 Zeichen)"
  }
}
